module.exports = __webpack_public_path__ + "static/media/momentum.daaa3c20.png";